export default {

    title: "Terhelés...",

    responses: {
        "404": {
            title: "Hiba történt",
            header: "Hiba történt",
            message: "Nem található érvényes token. Lehetséges, hogy a token lejárt."
        },
        "200": {
            title: "Sikeres",
            header: "Sikeres",
            message: "Kérését sikeresen feldolgoztuk."
        },
        "200_tfalogin": {
            title: "Bejelentkezés ellenőrzése",
            header: "@:views.tunnel.service.responses.200_tfalogin.title",
            message: "A bejelentkezés ellenőrizve."
        },
        "404_tfalogin": {
            title: "Bejelentkezés ellenőrzése",
            header: "@:views.tunnel.service.responses.404_tfalogin.title",
            message: "Nem található érvényes token. Lehetséges, hogy a token lejárt."
        },
        "200_tfaaddress": {
            title: "Cím ellenőrzése",
            header: "@:views.tunnel.service.responses.200_tfaaddress.title",
            message: "Köszönjük, hogy ellenőrizte a címét. Mostantól ezt választhatja szállítási címként rendelés leadásakor."
        },
        "404_tfaaddress": {
            title: "Cím ellenőrzése",
            header: "@:views.tunnel.service.responses.404_tfaaddress.title",
            message: "Nem található érvényes token. Lehetséges, hogy a token lejárt."
        },
        "201_delivery": {
            title: "Köszönöm",
            header: "Köszönöm",
            message: "Köszönöm a válaszát."
        },
        "201_shipment_received": {
            title: "Köszönöm",
            header: "Köszönöm",
            message: "Köszönöm a válaszát."
        },
        "400": {
            title: "Hibás kérés. Hiba történt.",
            header: "@:views.tunnel.service.responses.400.title",
            message: "Hibás kérés. Hiba történt."
        }
    }
}